export default "__VITE_ASSET__DhwDanWz__"